import React from 'react';
import {
  useTranslator,
  removeAuthCredentials,
  withLoading,
  SavePaymentArguments,
  MakePaymentArguments,
  ShippingOptionsResponseData,
  PaymentMethod,
  ShippingAddress,
} from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';
import Layout from '../../Layout/Layout';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import CheckoutForm from './CheckoutForm';
import { Link } from 'react-router-dom';

interface IPaymentMethodsContainer {
  payment: any;
  savePayment: (args: SavePaymentArguments) => Promise<unknown>;
  makePayment: (args: MakePaymentArguments) => Promise<unknown>;
  shoppingCartToken: string;
  pathThankYou: string;
  pathPaymentMethods: string;
  shippingOptions: ShippingOptionsResponseData;
  paymentMethods: PaymentMethod[];
  shipment: ShippingAddress;
  disableCodOption?: boolean;
}

const PaymentMethodsContainer: React.FC<IPaymentMethodsContainer> = ({
  payment,
  shoppingCartToken,
  shippingOptions,
  pathThankYou,
  pathPaymentMethods,
  savePayment,
  makePayment,
  paymentMethods,
  disableCodOption,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslator();

  const handleChangeAccount = (event: any) => {
    event.preventDefault();
    removeAuthCredentials();
    navigate('/cart/login/change-account');
  };

  localStorage.setItem('shopppingCartProductId', payment.products[0].saleProductVariant.id);

  return (
    <Layout simpleLayout>
      <div className="page-template-checkout full-height7">
        <Container className="py-xxl">
          <h1 className="text-center title-medium semi-bold mb-xl">{t('paymentMethods.title')}</h1>
          <p className="text-center user-email mb-xl">
            <span className="semi-bold">{payment.user.email}</span>{' '}
            <Link to={''} onClick={handleChangeAccount}>
              {t('paymentMethods.changeAccount')}
            </Link>
          </p>
          <CheckoutForm
            pathThankYou={pathThankYou}
            pathPaymentMethods={pathPaymentMethods}
            shoppingCartToken={shoppingCartToken}
            makePayment={makePayment}
            product={payment.products[0]}
            userData={{ email: payment.user.email, shipping: payment.user.shipping }}
            productPrice={payment.products[0].price}
            savePayment={savePayment}
            paymentMethods={paymentMethods}
            shippingOptions={shippingOptions}
            disableCodOption={disableCodOption}
          />
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder simpleLayout fullHeightMinusHeader />;

export default withLoading(PaymentMethodsContainer, Placeholder);
